export const OFFICE_NAME = 'Premium Homes';
export const OFFICE_ADDRESS = 'Rruga Pasho Hysa, Tiranë 1001, Albania';
export const OFFICE_PHONE = '+355 69 304 0629';
export const OFFICE_EMAIL = 'info@premiumhomes.al';
export const OFFICE_MAP_URL = 'https://goo.gl/maps/Jrnajow4TS6QousE6';
export const OFFICE_MAP_EMBED = 'https://www.google.com/maps?q=41.3284973,19.8455008&hl=sq&z=17&output=embed';
export const OFFICE_INSTAGRAM_URL = 'https://www.instagram.com/premium_homes__';
export const OFFICE_FACEBOOK_URL = 'https://www.facebook.com/PremiumHomess.al';
